<script setup lang="ts">
/**
 * UI-kit component
 * Category: Other
 * Name: ItemDropdown
 */
import type { ItemDropdownProps } from '../types/interfaces'

import { AppText } from '@shared/ui/typography'

import { useItemDropdown } from '../composables/use-item-dropdown.hook'

defineOptions({
  name: 'ItemDropdown',
})

withDefaults(defineProps<ItemDropdownProps>(), {
  text: '',
  title: '',
  disabled: false,
})

const emit = defineEmits<{
  click: []
}>()

const { handleClick } = useItemDropdown({
  onClick: () => emit('click'),
})
</script>

<template>
  <button
    class="drop-item"
    type="button"
    :title="title"
    :disabled="disabled"
    @click="handleClick"
  >
    <span
      v-if="$slots.iconLeft"
      class="drop-item__icon left"
    >
      <slot name="iconLeft" />
    </span>
    <AppText
      v-if="text"
      name="body1"
      color="blue-700"
      class="drop-item__text"
    >
      {{ text }}
    </AppText>
    <span
      v-if="$slots.iconRight"
      class="drop-item__icon right"
    >
      <slot name="iconRight" />
    </span>
  </button>
</template>

<style lang="scss" scoped src="../styles/_item-dropdown.scss" />
